<div class="flex gap-1 items-center">
  <span class="text-proffeo-muted text-sm">
    {{ 'task-details-modal-location-changed' | translate }}: {{ locationPath() }}
  </span>
</div>
